import colours from '../../../styles/colours';

import { createStyles } from '@material-ui/core';

const styles = createStyles({
  readonly: {
    display: 'inline-flex',
    color: 'inherit',
    background: 'transparent',
    paddingLeft: '2px',
    paddingRight: '2px'
  },

  label: {
    display: 'block',
    fontWeight: 'normal',
    clear: 'both',
    width: '100%',

    '&:after': {
      content: ' ',
      display: 'block'
    }
  },

  unspecified: {
    fontWeight: 'normal'
  },

  blue: {
    fontWeight: 'normal',
    color: colours.blueGrey500
  },

  'Auto-Size': {
    width: 'auto'
  },

  Small: {
    width: '80px'
  },

  Medium: {
    width: '160px'
  },

  Large: {
    width: '240px'
  },

  'Extra-Large': {
    width: '400px'
  },

  '@global': {
    '.entity-inline': {
      '& $readonly': {
        fontWeight: 'bold'
      }
    }
  },

  '@media print': {
    label: {
      fontWeight: 'bold'
    },
    readonly: {
      display: 'inherit !important'
    }
  }
});

export default styles;
